// wp-icons — Communication (11)
import { createWpIcon } from './createIcon.js';

export const Mail = createWpIcon('Mail', [
  ['rect', { width: 20, height: 16, x: 2, y: 4, rx: 2, key: 'a' }],
  ['path', { d: 'm22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7', key: 'b' }],
]);
export const MessageCircle = createWpIcon('MessageCircle', [
  ['path', { d: 'M7.9 20A9 9 0 1 0 4 16.1L2 22Z', key: 'a' }],
]);
export const MessageSquare = createWpIcon('MessageSquare', [
  ['path', { d: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z', key: 'a' }],
]);
export const Phone = createWpIcon('Phone', [
  ['path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z', key: 'a' }],
]);
export const PhoneCall = createWpIcon('PhoneCall', [
  ['path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z', key: 'a' }],
  ['path', { d: 'M14.05 2a9 9 0 0 1 8 7.94', key: 'b' }],
  ['path', { d: 'M14.05 6A5 5 0 0 1 18 10', key: 'c' }],
]);
export const PhoneIncoming = createWpIcon('PhoneIncoming', [
  ['polyline', { points: '16 2 16 8 22 8', key: 'a' }],
  ['line', { x1: 22, x2: 16, y1: 2, y2: 8, key: 'b' }],
  ['path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z', key: 'c' }],
]);
export const PhoneOutgoing = createWpIcon('PhoneOutgoing', [
  ['polyline', { points: '22 8 22 2 16 2', key: 'a' }],
  ['line', { x1: 16, x2: 22, y1: 8, y2: 2, key: 'b' }],
  ['path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z', key: 'c' }],
]);
export const PhoneForwarded = createWpIcon('PhoneForwarded', [
  ['polyline', { points: '18 2 22 6 18 10', key: 'a' }],
  ['line', { x1: 14, x2: 22, y1: 6, y2: 6, key: 'b' }],
  ['path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z', key: 'c' }],
]);
export const PhoneOff = createWpIcon('PhoneOff', [
  ['path', { d: 'M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67', key: 'a' }],
  ['path', { d: 'M5 5a2 2 0 0 0-2 2v2.72C3.87 10.72 4.62 12 5.87 12.87l.34.34a9.9 9.9 0 0 0 1.31 1.11', key: 'b' }],
  ['line', { x1: 2, x2: 22, y1: 2, y2: 22, key: 'c' }],
]);
export const Inbox = createWpIcon('Inbox', [
  ['polyline', { points: '22 12 16 12 14 15 10 15 8 12 2 12', key: 'a' }],
  ['path', { d: 'M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z', key: 'b' }],
]);
export const Bell = createWpIcon('Bell', [
  ['path', { d: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9', key: 'a' }],
  ['path', { d: 'M10.3 21a1.94 1.94 0 0 0 3.4 0', key: 'b' }],
]);
export const Paperclip = createWpIcon('Paperclip', [
  ['path', { d: 'M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 17.98 8.84l-8.58 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48', key: 'a' }],
]);
